import React from 'react';
import { Control, UseFormGetValues, UseFormRegister, UseFormTrigger, UseFormWatch } from 'react-hook-form';
import { Trans } from 'react-i18next';
import useProfileContactsDialog from './profileContactsDialog-hook';
import { ButtonTypes, IProfilecontactItem } from '../../../../../../Interfaces/componentTypes';
import { IProfileContactsForm } from '../../../../../../Interfaces/formValue-interfaces';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import Button from '../../../../../../Components/Button/button';
import styles from './profileContactsDialog.module.scss';

export interface IProfileContactsDialog {
    data: IProfilecontactItem,
    register: UseFormRegister<IProfileContactsForm>,
    getValues: UseFormGetValues<IProfileContactsForm>,
    control: Control<IProfileContactsForm, any, IProfileContactsForm>,
    onConfirm: (id: keyof IProfileContactsForm, value: any) => void,
    trigger: UseFormTrigger<IProfileContactsForm>,
    watch: UseFormWatch<IProfileContactsForm>,
    onClose: () => void,
}

const ProfileContactsDialog: React.FC<IProfileContactsDialog> = (props) => {
    const { data, getValues, onConfirm, onClose } = props;
    const { t } = useLanguagesHooks();
    const { renderFormInput, isCurrentValid } = useProfileContactsDialog(props);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={data.icon} alt={`${data.icon}.svg`} />
                <p>
                    {data.id === 'phone_numbers' ? t('Sign_Up.Phone') : data.id.toUpperCase()}
                </p>
            </div>
            <div className={styles.form}>
                <p>
                    <Trans
                        i18nKey={`My_Business.Business_Profile.Contact.Labels.${data.id}`}
                        components={{ contactLink: <span className={styles.link} /> }}
                    />
                </p>
                {renderFormInput(data.id)}
            </div>
            <div className={styles.buttonsRow}>
                <Button
                    buttonType={ButtonTypes.Secondary}
                    title={t('Buttons.Close')}
                    type='button'
                    onClick={onClose}
                    buttonStyle={styles.closeButton}
                />
                <Button
                    buttonType={isCurrentValid ? ButtonTypes.Primery : ButtonTypes.Disabled}
                    title={t('Buttons.Save')}
                    type='button'
                    onClick={() => onConfirm(data.id as keyof IProfileContactsForm, getValues(data.id as keyof IProfileContactsForm))}
                    buttonStyle={styles.button}
                    disable={!isCurrentValid}
                />
            </div>
        </div>
    );
}

export default ProfileContactsDialog;
